export const tipoExibicaoAcompanhamento = {
  fixo: 'FIXO',
  fixoSistema: 'FIXOSISTEMA',
  naoFixo: 'NAOFIXO',
};
